// Workflows.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Workflows() {
    return (
        <PageLayout title="Workflows" subtitle="Workflows overview">
            <div className="container flex col box-container">
                {/* <div className="box">Workflows</div> */}
            </div>
        </PageLayout>   
    );
}

export default Workflows;
